import useNotificationHandler from "hooks/useNotificationHandler";
import { MUTATION_KEYS } from "library/shared";
import { IUserSettings, IUserSettingsPayload } from "library/types";
import { useMutation } from "react-query";
import api from "service/api";
import { useInvalidateUserAppSettings } from "./useGetUserAppSettings";

type Params = {
  payload: IUserSettingsPayload[];
};

const addAppSetting = async ({ payload }: Params) => {
  const response = await api.post(`/uad/addappsettings`, payload);

  return response.data as IUserSettings[];
};

export function useAddAppSetting(refetch = true) {
  const invalidateUserAppSettings = useInvalidateUserAppSettings();
  const { handleAddAxiosErrorNotification } = useNotificationHandler();

  return useMutation(addAppSetting, {
    mutationKey: MUTATION_KEYS.addUserSettings,
    onSuccess: () => {
      if (refetch) {
        invalidateUserAppSettings();
      }
    },
    onError: (error) => {
      // handle error
      handleAddAxiosErrorNotification(error);
    },
  });
}
